const translateAPI = {

  install(Vue) {

    Vue.baseURL = 'https://api.zincorporacoes.com.br/',
    Vue.pathToken = '/oauth/token',
    Vue.pathEnterprises = '/api/empreendimentozmais?idIncorporadora=21',
    Vue.clientId = "27",
    Vue.clientSecret = "u7znRhT2oMVIOrYHBiGH8BcYYipYjniYviWDxu6A"

  }

}

export default translateAPI



// WEBPACK FOOTER //
// ./src/translate-api.js